var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Linkedin-Company',{attrs:{"companyData":_vm.companyData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }